import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { OrigemDocumentoFiscalRecebidoEnum } from '../../../../shared/enums/repo-dfe/origem-documento-fiscal-recebido.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { PainelDFeRecebidoService } from '../../../../shared/services/apis/repo-dfe/painel-dfe-recebido.service';
import { DetalheCTeRecebidoResponse } from '../../../../shared/services/responses/repo-dfe/detalhe-cte-recebido.response';
import { CTeDetalheComponent } from '../cte-detalhe/cte-detalhe.component';

@Component({
  selector: 'app-detalhe-cte-recebido', standalone: true,
  imports: [HeaderComponent, LoadingBoxComponent, CTeDetalheComponent],
  templateUrl: './detalhe-cte-recebido.component.html',
  styleUrls: ['./detalhe-cte-recebido.component.css']
})
export class DetalheCTeRecebidoComponent implements OnInit {
  readonly moduloEnum = ModuloEnum.NotasFiscais;
  readonly funcionalidadeEnum = FuncionalidadeEnum.NotasFiscais_PainelNotaRecebida;
  isLoading = true;
  documento: DetalheCTeRecebidoResponse | null = null;

  constructor(private route: ActivatedRoute, private router: Router,
    private service: PainelDFeRecebidoService, private alert: AlertService) { }

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('idCTeRecebido'));
    const origem = Number(this.route.snapshot.queryParamMap.get('origemDocumentoFiscalRecebido'));
    if (!id || ![OrigemDocumentoFiscalRecebidoEnum.EstruturaAntiga, OrigemDocumentoFiscalRecebidoEnum.EstruturaNova].includes(origem)) {
      this.alert.show('Erro', 'CT-e recebido inválido.', AlertType.error);
      this.router.navigate(['/notas-fiscais/notas-recebidas']);
      return;
    }
    this.service.obterCTeRecebido(id, origem).subscribe({
      next: response => {
        this.isLoading = false;
        if (response.isError) {
          this.alert.show('Aviso', response.errorDescription, AlertType.warning);
          this.router.navigate(['/notas-fiscais/notas-recebidas']);
          return;
        }
        this.documento = response;
      },
      error: error => { this.isLoading = false; this.alert.show('Erro inesperado', error.message, AlertType.error); }
    });
  }
}
